import { render, staticRenderFns } from "./Robots.vue?vue&type=template&id=557211cb&"
import script from "./Robots.vue?vue&type=script&lang=js&"
export * from "./Robots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/jrspieker/evnotify/EVNotifyPWA/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
